<template>
	<!-- ЛАФЧЕ.ORG: старият текстови WHOIS изглед е потиснат нарочно -
	цялата тази информация вече се показва в WhoisModal.vue (модален
	прозорец), не искаме двойно показване в чата/личните. Празен template,
	НО props декларацията по-долу остава - иначе Vue "изсипва" непотърсените
	network/message props директно като HTML атрибути върху този елемент
	(fallthrough), причинявайки видими [object Object] артефакти -->
	<span></span>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {ClientNetwork, ClientMessage} from "../../js/types";

export default defineComponent({
	name: "MessageTypeWhois",
	props: {
		network: {
			type: Object as PropType<ClientNetwork>,
			required: true,
		},
		message: {
			type: Object as PropType<ClientMessage>,
			required: true,
		},
	},
});
</script>
